import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ChevronLeftOutlined } from '@material-ui/icons';
import React, { CSSProperties, useContext } from 'react';
import LocalizationContext from '../../contexts/LocalizationContext';

const useStyles = makeStyles({
    backButton: { display: 'block', margin: '10px 0 10px -14px', padding: '6px 8px' },
});

interface BackButtonProps {
    style?: CSSProperties;
    onClick?: () => void;
}

const BackButton = ({ style, onClick }: BackButtonProps) => {
    const classes = useStyles();
    const localization = useContext(LocalizationContext);

    return (
        <Button style={style} className={classes.backButton} onClick={onClick}>
            <div style={{ display: 'flex' }}>
                <ChevronLeftOutlined style={{ margin: 'auto 4px auto 0' }} />
                <div style={{ margin: 'auto 0', paddingBottom: '1px', paddingRight: '4px' }}>{localization.strings.back}</div>
            </div>
        </Button>
    );
};

export default BackButton;
